import { render, staticRenderFns } from "./IconExclamationMarkStroke.vue?vue&type=template&id=64a2a5ea&"
import script from "./IconExclamationMarkStroke.vue?vue&type=script&lang=js&"
export * from "./IconExclamationMarkStroke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports